/**
 * Single source of truth for public marketing routes (`MAR-1122`).
 *
 * Used by `app/plugins/firebase.client.ts`, `app/middleware/auth.global.ts`, and
 * `app/layouts/default.vue`:
 * - `auth.global.ts` returns immediately on marketing routes without blocking navigation.
 * - `firebase.client.ts` starts `ensureFirebaseAuth()` in the background on marketing routes
 *   (without awaiting it in the plugin body), so SSR-unauthenticated visits show a neutral
 *   loading spinner in the auth CTA slot until Firebase checks IndexedDB, while SSR-authenticated
 *   visits keep `loading = false` and `"Ir al dashboard"` on first paint.
 * - `/login`, `/addin`, and `/app/**` are NOT marketing routes; they await `ensureFirebaseAuth()`
 *   eagerly.
 */
const MARKETING_EXACT_PATHS = new Set(['/', '/privacidad', '/terminos', '/seguridad'])

export function isMarketingPath(path: string): boolean {
  const normalized = path.length > 1 ? path.replace(/\/+$/, '') : path
  if (MARKETING_EXACT_PATHS.has(normalized)) return true
  return normalized === '/blog' || normalized.startsWith('/blog/')
}

